import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type { ViewComponent } from "@frui.ts/views";
import { Check, Input } from "@frui.ts/bootstrap";
import DatePickerBox from "controls/datePickerBox";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import type TerminateExemptionViewModel from "viewModels/callCenter/search/exemptions/terminateExemption/terminateExemptionViewModel";
import { formatDateTime } from "utils/localizations";
import { emptyValue } from "utils/emptyValue";

const TerminateFormSection: ViewComponent<TerminateExemptionViewModel> = observer(({ vm }) => {
  return (
    <>
      <div className="bg-light mb-4 px-4 pt-4 rounded">
        <Form.Row>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("countryId")}</Form.Label>
            <div>{vm.translateCountryId(vm.exemptionResponse.vehicle?.countryId)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("licensePlate")}</Form.Label>
            <div>{vm.exemptionResponse.vehicle?.licensePlate}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("validSince")}</Form.Label>
            <div className="text-nowrap">
              {vm.exemptionResponse.validSince ? formatDateTime(vm.exemptionResponse.validSince) : emptyValue}
            </div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("validUntil")}</Form.Label>
            <div className="text-nowrap">
              {vm.exemptionResponse.validUntil ? formatDateTime(vm.exemptionResponse.validUntil) : emptyValue}
            </div>
          </Form.Group>
          <Form.Group as={Col} sm={12} xs={12}>
            <Form.Label>{vm.translate("exemptionReasonId")}</Form.Label>
            <div>{vm.getExemptionReasonDescription(vm.exemptionResponse.exemptionReasonId) ?? emptyValue}</div>
          </Form.Group>
        </Form.Row>
      </div>
      <Form.Row>
        <FormGroup as={Col} sm={6} xs={6} target={vm.item} property="validUntilDate">
          <FormLabel>{vm.translateAttribute("exemption", "validUntilDate")}</FormLabel>
          {vm.item && (
            <DatePickerBox
              disabled={vm.isDisabled}
              disabledShowTime
              placeholder={vm.translateAttribute("exemption", "validUntilDate")}
            />
          )}
        </FormGroup>
        <FormGroup
          as={Col}
          sm={6}
          xs={6}
          target={vm.item}
          property="isImmediateCancellation"
          className="d-flex justify-content-center align-items-center"
          style={{ marginTop: "2rem" }}>
          <Check custom type="checkbox" label={vm.translate("isImmediateCancellation")} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="cancellationRecordId">
          <FormLabel>{vm.translate("cancellationRecordId")}</FormLabel>
          <Input />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="cancellationReason">
          <FormLabel>{vm.translate("cancellationReason")}</FormLabel>
          <Input as="textarea" rows={4} />
        </FormGroup>
      </Form.Row>
    </>
  );
});

export default TerminateFormSection;
